// eslint-disable-next-line
export const generateTarget = (url) => {
  if (url.indexOf('http') === 0) {
    return '_blank';
  }

  return '_self';
};

export const getCurrentUrl = () => {
  return window.location.href;
}

export const setCurrentUrl = (pathName) => {
  window.location.href = pathName;
}

export const urlContains = (keyWord) => {
  return getCurrentUrl().includes(keyWord);
}



// WEBPACK FOOTER //
// ./src/Common/Helpers/UrlHelper.js